import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LabGroupApi } from '../api/labgroup.api';
import { switchMap, map } from 'rxjs/operators';
import { LabGroupData, LabGroup } from '../../../interfaces/masters/labgroup' ;
@Injectable()
export class LabGroupService extends LabGroupData {

    constructor(private api: LabGroupApi) {
      super();
    }
  
  
    list(url: string): Observable<LabGroup[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<LabGroup>{
        return this.api.getById(url);
    }
  
    create(url: string, data:LabGroup): Observable<LabGroup[]> {
      return this.api.add(url,data);
    }

    createList(url: string, data:any): Observable<any> {
      return this.api.addList(url,data);
    }
  
    updateList(url: string, data:any): Observable<any> {
      return this.api.editList(url,data);
    }
    
    update(url: string, data:LabGroup): Observable<LabGroup> {
      return this.api.update(url,data);
    }

      //For Labunitmst Excelport
      postData(url: string, data:any[]): Observable<any> {
        return this.api.addData(url,data);
      }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  